import React from 'react';
import { CompanyName } from '../../utils/Constants';

function GeneralHeader({
  headerMainImage,
  headerMobileImage,
  mainTitle,
  subtitle,
  mainImage,
  secondaryImage,
}) {
  return (
    <header className='text-center grid pt-6 lg:pt-2'>
      <section>
        <img
          src={headerMainImage}
          alt='Mistress Sammi Smith about me header'
          className='hidden md:block mx-auto max-w-[80vw] xl:max-w-[40vw] max-h-[20vh]'
        />
        <img
          src={headerMobileImage}
          alt='Mistress Sammi Smith about me header'
          className='md:hidden mx-auto max-w-[80vw] max-h-[25vh]'
        />
      </section>
      <article>
        <div className='border-2 border-solid md:-mt-2 mb-2 border-colour1 w-fit mx-auto px-4 lg:px-8 py-1 rounded-full shadow-cardShadowBold'>
          <h1 className='font-semibold'>{mainTitle}</h1>
        </div>
        <h2>{subtitle}</h2>
      </article>
      {/* Phone */}
      {mainImage && (
        <>
          <section className='lg:hidden'>
            <img
              src={mainImage}
              alt={`${CompanyName} gorgeous ts and smoking`}
              className='mx-auto max-h-[50vh] mt-2'
            />
          </section>

          {/* Main */}
          <section className='hidden lg:grid w-fit mx-auto '>
            <img
              src={mainImage}
              alt={`${CompanyName} gorgeous ts and smoking`}
              className='mx-auto max-h-[50vh] mt-2'
            />
          </section>
        </>
      )}
    </header>
  );
}

export default GeneralHeader;
